import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { SharedModule } from '@shared/shared.module'

import { LinxioContentComponent } from './content.component'

@NgModule({
  declarations: [LinxioContentComponent],
  imports: [RouterModule, SharedModule],
  exports: [LinxioContentComponent],
})
export class ContentModule {}
